import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { graphql } from 'gatsby'
import {
  Button,
  Container,
  Section,
  SectionTitle,
} from 'chaoskit/src/components'
import { tealDarkBlue } from 'chaoskit/src/assets/styles/utility/gradient'

import BaseLayout from '~layouts/BaseLayout'
import Hero, { HeroContent, HeroTitleWrapper, HeroTitle } from '~partials/Hero'
import ActionCard from '~components/ActionCard'
import Data from '~components/Data'
import Icon from '~components/Icon'
import HelmetSEO from '~partials/global/HelmetSEO'

const GameDay = ({
  data: {
    file: {
      childMdx: { frontmatter: pageData },
    },
  },
}) => {
  const theme = useTheme()

  return (
    <BaseLayout>
      <HelmetSEO title={pageData.title} description={pageData.description} />
      <Hero compact css={tealDarkBlue(theme)}>
        <HeroContent>
          <Container>
            <HeroTitleWrapper>
              <HeroTitle>
                <Data>{pageData.hero.heading}</Data>
              </HeroTitle>
            </HeroTitleWrapper>
          </Container>
        </HeroContent>
      </Hero>
      <Section space="xlarge" css={{ background: theme.color.panel.base }}>
        <Container>
          <SectionTitle
            title={<Data>{pageData.files.heading}</Data>}
            sub={<Data>{pageData.files.blurb}</Data>}
          />
          <div
            css={{
              display: 'grid',
              gap: theme.space.large,

              [theme.mq.small]: {
                gridTemplateColumns: 'repeat(2, 1fr)',
              },

              [theme.mq.medium]: {
                gridTemplateColumns: 'repeat(3, 1fr)',
              },
            }}
          >
            {pageData.files.downloads.map((download) => (
              <ActionCard
                key={download.title}
                url={download.src}
                css={{
                  '.G__ActionCard__Content': {
                    textAlign: 'center',
                  },
                }}
              >
                <Icon
                  icon="download"
                  size="large"
                  css={{
                    marginRight: theme.space.small,
                    color: theme.color.primary.base,
                  }}
                />
                <Data>{download.title}</Data>
              </ActionCard>
            ))}
          </div>
          <div css={{ textAlign: 'center', marginTop: theme.space.xlarge }}>
            <Button type="outlinePrimary" url={pageData.files.packageDownload}>
              Download All
            </Button>
          </div>
        </Container>
      </Section>
    </BaseLayout>
  )
}

GameDay.propTypes = {
  data: PropTypes.object.isRequired,
}

export default GameDay

export const pageQuery = graphql`
  query GameDayPageData {
    file(name: { eq: "gameday" }, absolutePath: { regex: "/src/data/" }) {
      childMdx {
        frontmatter {
          title
          description
          hero {
            heading
          }
          files {
            heading
            blurb
            downloads {
              src
              title
            }
            packageDownload
          }
        }
      }
    }
  }
`
